import { stringify } from "qs";

class FETIASEntity {
    constructor(json, schema) {
        this.json = json;
        this.schema = schema;
    }

    hasChange(previous, displayName, columnName) {
        try {
            let information = this.schema.find(x => x.displayName == displayName);
            if (information != null && previous != null) {
                switch (information.type) {
                    case 14:
                    case 15:
                        if (columnName != null) {
                            let currentRows = this.field(displayName);
                            let previousRows = previous.field(displayName);
                            let change = currentRows.some(row => {
                                //if not found, changed
                                let previousRow = previousRows.find(x => x.field('id') == row.field('id'));
                                if (previousRow != null) {
                                    return row.hasChange(previousRow, columnName);
                                }

                                return true;
                            });
                            return change;
                        }
                        return JSON.stringify(this.field(displayName)) != JSON.stringify(previous.field(displayName))
                }

                return this.field(displayName) != previous.field(displayName);
            }
        }
        catch (ex) {
            console.log(ex);
        }

        return true;
    }

    field(displayName) {
        if (this.json == null) {
            console.log(json)
        }


        if (displayName == 'id')
            return this.json['id'];

        let information = this.schema.find(x => x.displayName == displayName);
        if (information != null) {
            switch (information.type) {
                //table & list
                case 14:
                case 15:
                    if (this.json[information.fieldName] == null)
                        return [];
                    return this.json[information.fieldName].map(x => new FETIASEntity(x, information.fields))

                case 3:
                case 4:
                    if (this.json[information.fieldName] == null)
                        return 0.0;
                    return parseFloat(this.json[information.fieldName] || 0);
                case 2:
                    if (this.json[information.fieldName] == null)
                        return 0;
                    return parseInt(this.json[information.fieldName] || 0);


            }

            return this.json[information.fieldName];
        }
    }

    set(displayName, value) {
        let information = this.schema.find(x => x.displayName == displayName);
        if (information != null) {
            console.log(`${displayName}->${value}`)
            this.json[information.fieldName] = value;
        }
    }
}

export default FETIASEntity;

